export const openModal = payload => {
  return {
    type: 'POSITIONED_MODAL_OPEN',
    payload
  }
}

export const closeModal = () => {
  return {
    type: 'POSITIONED_MODAL_CLOSE'
  }
}